<ng-container *transloco="let t">
<ng-template #checkLists>
  @if (isEditEnabled && !isLoadingChecklists) {
    <h5 class="mb-5">{{ t('wizard.checklists.selectChecklistsPrompt') }}</h5>
    @if (checklists) {
      <checklist-picker [checklists]="checklists" [selectedChecklistIds]="selectedChecklistIds"
        (selectedChecklistsChanged)="onSelectedChecklistsChanged($event)">
      </checklist-picker>
    }
  }
  @if (!isLoadingChecklists && !isEditEnabled && selectedChecklistIds && selectedChecklistIds.length && checklists) {
    <div class="col-md-12 fv-row mt-2 mb-2" style="min-height: 180px;">
      @for (borrower of borrowersToRunTroughTheChecklist; track borrower.borrowerId; let i = $index) {
        <borrower-checklists
          [hidden]="currentBorrowerIndex !== i"
          #borrowerChecklists
          [applicationId]="mortgage.applicationId"
          [borrower]="borrower"
          [selectedChecklistIds]="selectedChecklistIds"
          [questionMetaData]="questionMetaData"
          [questionsByChecklist]="questionsByChecklist"
          [isPrimaryBorrower]="currentBorrower.borrowerId === borrower.borrowerId"
          (allQuestionsAreTriggerOnly)="onBorrowerNotifiedThatAllQuestionsAreTriggerOnly($event)">
        </borrower-checklists>
      }
    </div>

    @if (!showSpinnerOnMainContent) {
      <div class="d-flex flex-stack pt-5 pb-5">
        <div class="mr-2">
          @if (showPreviousButton) {
            <button type="button" class="btn btn-lg btn-light-primary me-3"
              (click)="onPreviousQuestionClicked()">
              <span class="svg-icon svg-icon-4 me-1">
                <duotone-navigation-left-svg-icon></duotone-navigation-left-svg-icon>
              </span>
              {{ t('common.back') }}
            </button>
          }
        </div>
        <div>
          @if (showNextButton) {
            <button type="button" class="btn btn-lg btn-primary"
              (click)="onNextQuestionClicked()">{{ t('common.next') }}
              <span class="svg-icon svg-icon-4 ms-1 me-0">
                <duotone-navigation-right-svg-icon></duotone-navigation-right-svg-icon>
              </span>
            </button>
          }
        </div>
      </div>
    }
  }
</ng-template>

<wizard-step-template [showSpinnerOnMainContent]="showSpinnerOnMainContent" [stepMainTemplate]="checkLists" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
